// extracted by mini-css-extract-plugin
export var quillEditor = "_oa-1";
export var variable = "_oa-0";